var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section", attrs: { id: "customer-page" } },
    [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-7" },
          [
            _c(
              "b-field",
              [
                _c("b-input", {
                  attrs: { icon: "search", placeholder: "Search" },
                  on: { input: _vm.changeQuery },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "column is-5" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    tag: "router-link",
                    to: { name: "export-recap-all" },
                    "icon-left": "history",
                    type: "is-link",
                  },
                },
                [_vm._v(" File import history ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { type: "is-primary", "icon-left": "folder-plus" },
                  on: {
                    click: function ($event) {
                      return _vm.createModal()
                    },
                  },
                },
                [_vm._v(" Add new file setting ")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            scroll: "keep",
            "has-modal-card": "",
            active: _vm.isDuplicating,
          },
          on: {
            "update:active": function ($event) {
              _vm.isDuplicating = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-card",
              staticStyle: { "min-height": "560px" },
            },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _vm._v(" Duplicate file setting "),
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c("div", [
                    _vm._v(
                      "Select which customer you want this file setting to be copied for"
                    ),
                  ]),
                  _c("multiselect", {
                    attrs: {
                      options: _vm.customers,
                      "custom-label": (obj) => obj.id + " - " + obj.name,
                      "close-on-select": true,
                      placeholder: "Select customer...",
                    },
                    model: {
                      value: _vm.duplicateTo,
                      callback: function ($$v) {
                        _vm.duplicateTo = $$v
                      },
                      expression: "duplicateTo",
                    },
                  }),
                ],
                1
              ),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-danger is-outlined",
                      on: {
                        click: function ($event) {
                          _vm.isDuplicating = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-info",
                      class: { "is-loading": _vm.duplicateLoading },
                      attrs: { disabled: _vm.duplicateTo === null },
                      on: { click: _vm.duplicateFileSetting },
                    },
                    [_vm._v(" Duplicate ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            scroll: "keep",
            "has-modal-card": "",
            active: _vm.isCreating,
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreating = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-card",
              staticStyle: { "min-height": "560px" },
            },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _vm._v(" Create file setting "),
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c("div", [
                    _vm._v(
                      "Select which customer you want a file setting to be created for"
                    ),
                  ]),
                  _c("multiselect", {
                    attrs: {
                      options: _vm.customers,
                      "custom-label": (obj) => obj.id + " - " + obj.name,
                      "close-on-select": true,
                      placeholder: "Select customer...",
                    },
                    model: {
                      value: _vm.createFor,
                      callback: function ($$v) {
                        _vm.createFor = $$v
                      },
                      expression: "createFor",
                    },
                  }),
                ],
                1
              ),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-danger is-outlined",
                      on: {
                        click: function ($event) {
                          _vm.isCreating = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-info",
                      class: { "is-loading": _vm.duplicateLoading },
                      attrs: { disabled: _vm.createFor === null },
                      on: { click: _vm.createFileSetting },
                    },
                    [_vm._v(" Create ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "b-table",
        {
          staticClass: "mt-10",
          attrs: {
            data: _vm.filteredCustomerFileSettings,
            loading: _vm.isLoading,
            "default-sort": "customer.name",
            paginated: "",
            striped: "",
            narrowed: "",
          },
        },
        [
          _c("b-table-column", {
            attrs: { field: "customer.id", label: "Customer id", sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.customer.id) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              field: "customer.name",
              label: "Customer name",
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.customer.name) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "table", label: "Type", sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$lodash.upperFirst(props.row.table)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { field: "parser", label: "Actions", width: "170" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    props.row.parser === "edi"
                      ? _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: "View natural rubber page",
                              type: "is-link",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                size: "is-small",
                                type: "is-link",
                                "icon-left": "tree",
                                tag: "router-link",
                                to: { name: "shipping-instructions" },
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: "View file history",
                              type: "is-link",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                size: "is-small",
                                type: "is-link",
                                "icon-left": "align-center",
                                tag: "router-link",
                                to: {
                                  name: "export-recap",
                                  params: { fip_id: props.row.id },
                                },
                              },
                            }),
                          ],
                          1
                        ),
                    _c(
                      "b-tooltip",
                      { attrs: { label: "Duplicate", type: "is-info" } },
                      [
                        _c("b-button", {
                          attrs: {
                            size: "is-small",
                            type: "is-info",
                            "icon-left": "plus",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.duplicateModal(
                                props.row.customer.id,
                                props.row.fipId
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-tooltip",
                      { attrs: { label: "Edit", type: "is-primary" } },
                      [
                        _c("b-button", {
                          attrs: {
                            size: "is-small",
                            type: "is-primary",
                            "icon-left": "edit",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setEditing(
                                props.row.customer.id,
                                props.row.fipId
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-tooltip",
                      { attrs: { label: "Delete", type: "is-danger" } },
                      [
                        _c("b-button", {
                          attrs: {
                            size: "is-small",
                            type: "is-danger",
                            "icon-left": "times",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteFileSettings(
                                props.row.customer.id,
                                props.row.fipId
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          label: "Test validity",
                          type: "is-warning is-white",
                        },
                      },
                      [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false",
                              },
                            ],
                            staticClass: "file-input",
                            attrs: {
                              type: "file",
                              name: "export",
                              required: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.exportFile(
                                  $event,
                                  props.row.fipId,
                                  props.row.table
                                )
                              },
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "is-warning is-small button",
                              class: {
                                "is-loading": _vm.testLoading[props.row.fipId],
                              },
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "upload",
                                  type: "is-white",
                                  size: "is-small",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "template",
            { slot: "empty" },
            [
              _c("nothing-here", {
                attrs: {
                  content: "No file setting matching your criteria was found",
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }